/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-11-11 19:24:16
 */

import React, { Component } from "react";
import Preparation from "../components/preparation/preparation";
import { DataService } from "../services/data.service";
import { withRouter } from "react-router-dom";

import LocationImg from "../assets/images/location.png";
import LocationDarkImg from "../assets/images/location-white.png";
import CalendarImg from "../assets/images/calender_org.png";
import CalendarImgBlack from "../assets/images/calender_gry.png";
import Journey from "../components/journey/journey";
import swal from "sweetalert";
import moment from "moment";
import $ from "jquery";

import * as handler from "../components/utils/handler";
import RefreshButton from "./../components/utils/refreshButton";
import DangerButton from "../components/utils/dangerButton";
import IconButton from "../components/utils/iconButton";
import Loader from "../components/loader/loader";
import ModalHead from "../components/modal-head/modalHead";

const queryString = require("query-string");
let language = queryString.parse(window.location.search).lang;
let appointmentNumber = queryString.parse(
  window.location.search
).appointmentnumber;
class UpdateAppointment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lang: {},

      // response: null,

      // singleBranchDetails: [],
      // isBranchPage: false,
      // selectedBranchFromMap: null,

      // dataLoaded: true,

      // heading: null,

      // isConfirmedReschedule: false,

      issueTicket: false, //from branch map
      issueQrTicket: false,
      isSingleBranchDetailsLoaded: false,

      // this.props.getData().response?.data?.previous_appointment_info !==
      //   undefined &&
      // this.props.getData().response?.data?.previous_appointment_info !== null
      //   ? this.props.getData().response?.data?.previous_appointment_info
      //       .address
      //   : this.props.getData().singleBranchDetails.length > 0
      //   ? this.props.getData().singleBranchDetails[0].Address
      //   : this.props.getData().selectedBranchFromMap !== null
      //   ? this.props.getData().selectedBranchFromMap.Address
      //   : null,

      // this.props.getData().response?.data.previous_appointment_info !==
      //   undefined &&
      // this.props.getData().response?.data.previous_appointment_info !== null
      //   ? this.props.getData().response?.data.previous_appointment_info
      //       .branch_title
      //   : this.props.getData().singleBranchDetails.length > 0
      //   ? this.props.getData().singleBranchDetails[0].BranchTitle
      //   : this.props.getData().selectedBranchFromMap !== null
      //   ? this.props.getData().selectedBranchFromMap.BranchTitle
      //   : null,
      response: null,
    };
    this.getAppointmentInfo();
  }

  getAppointmentInfo = async () => {
    this.setState({ dataLoaded: false });
    try {
      let response = await this.dataService.getAppointmentInfo(
        appointmentNumber
      );
      if (
        response.data.response_code === 100 ||
        response.data.response_code === 106 ||
        response.data.message === "success"
      ) {
        console.log("Get Appointment Info: ", response);
        this.setState({
          response: response?.data?.appointment_info,
          dataLoaded: true,
        });
      } else if (response.data.response_code === 102) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.AppointmentNotFound,
          this.state.lang.Ok,
          ""
        );
      } else {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok,
          ""
        );
      }
    } catch (error) {
      handler.showErrMsg(
        this.state.lang.Error,
        this.state.lang.SomeThingWentWrong,
        this.state.lang.Ok,
        ""
      );
      // this.setState({ isInfoDataLoaded: false, dataLoaded: true });
      console.log("ERROR: ", error.message);
    }
  };
  URL = window["app-config"].URL;
  runApp = window["app-config"].runApp;
  enableCategorySelection = window["app-config"].enableCategorySelection;
  userDetailsConfig = window["app-config"].userDetails;
  showGreetings = window["app-config"].ui.showGreetings;
  color = window["app-config"].ui.confirmScreen;
  icons = window["app-config"].ui.icons;
  defaultLanguage = window["app-config"].defaultLang;
  refreshInterval = window["app-config"].applicationProperties.refreshInterval;
  appRoute = window["app-config"].applicationProperties.appRoute;
  notificationSound = window["app-config"].notificationSound;
  popupExpiry = window["app-config"].ui.popupExpiry;
  dataService = new DataService();

  cancelButtonText = "";
  rescheduleButtonText = "";
  DoYouWantToRescheduleOrCancel = "";
  Attention = "";
  AppointmentAlreadyCanceled = "";
  AppointmentInfoNoValidToCancel = "";
  AlreadyServed = "";
  someThingWentWrong = "";
  error = "";
  For = "";
  Ok = "";
  CantCancelApptTcktIssued = "";
  AppointmentExpired = "";
  AppointmentCanceledAutomatically = "";
  Yes = "";
  No = "";
  TicketIssuedOn = "";
  WaitTime = "";
  Where = "";
  TotalWaitingTickets = "";
  CancelTicketConfirmation = "";
  UrlNotFound = "";
  InternetConnectionError = "";
  TicketNumber = "";
  BookingRef = "";
  Name = "";
  Email = "";
  PhoneNumber = "";
  NoOfPeople = "";
  WaitTimeMsg = "";
  Greetings = "";
  ServerNotResponding = "";
  TicketNotFound = "";

  // getAppinfo = async () => {
  //   const response = await this.getAppointmentInfo();

  //   return response;
  // };
  componentDidMount() {
    // this.setState({ response: this.getAppinfo() });
    // this.getAppointmentInfo();
    // console.log(this.props.getData());
    // this.generateUrl();
    handler.blinkText(".blink");

    // if (
    //   this.state.issueTicket ||
    //   this.state.issueQrTicket
    // ) {
    //   localStorage.setItem("confirmed", true);
    //   localStorage.setItem("confirmedDate", moment().toDate().toDateString());
    //   localStorage.setItem("prevState", JSON.stringify(this.props.getData()));
    // }

    let lang;
    if (localStorage.getItem("lang") === "es") {
      lang = window["localization"].es;
    } else if (localStorage.getItem("lang") === "ar") {
      lang = window["localization"].ar;
    } else if (localStorage.getItem("lang") === "en") {
      lang = window["localization"].en;
    } else if (localStorage.getItem("lang") === "ur") {
      lang = window["localization"].ur;
    } else {
      let defaultLang = this.defaultLanguage;
      lang = window["localization"][defaultLang];
    }
    this.setState({ lang: lang });
  }

  getDateTime = () => {
    return (
      <div className="booking-summary-date">
        <p className="sameFont">
          {this.state.response?.appointment_date !== null
            ? this.state.response?.appointment_date
            : null}
          &nbsp;{" "}
          {this.state.response?.start_time !== null
            ? this.state.response?.start_time
            : null}
        </p>
      </div>
    );
  };

  getBranchAddress = () => {
    if (
      this.state.response?.data?.previous_appointment_info !== undefined &&
      this.state.response?.data?.previous_appointment_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <div className="top-text">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.Where}
            </strong>
          </div>
          <p className="sameFont">
            {`${this.state.response?.branch_name} | ${this.state.response?.branch_address}`}
          </p>
          <p className="sameFont">{this.state.response?.branch_contact}</p>
        </div>
      );
    } else {
      return (
        <div className="booking-summary-date">
          <div className="top-text">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.Where}
            </strong>
          </div>

          <p className="sameFont">
            {`${this.state.response?.branch_name} | ${this.state.response?.branch_address}`}
          </p>
          <p className="sameFont">{this.state.response?.branch_contact}</p>
        </div>
      );
    }
  };

  getAppointmentNumber = () => {
    return (
      <div className="booking-summary-date">
        <div className="booking-summary-details">
          <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.BookingRef}
          </strong>
        </div>
        <p
          className="sameFont"
          style={{ fontSize: "24px", fontWeight: "bold", color: "#000" }}
        >
          {this.state.response?.appointment_number}
        </p>
      </div>
    );
  };

  getTicketIssuedDateTime = () => {
    if (
      this.state.response?.data?.ticket_info !== undefined &&
      this.state.response?.data?.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          {/* <strong className="sameHeads sameTextColor" style={{ color: this.color.headsColor }}>
            {this.TicketIssuedOn}
          </strong> */}
          <p className="sameFont">
            {moment(this.state.response?.data?.ticket_info.issued_on).format(
              "DD-MMM-YYYY hh:mm A"
            )}
          </p>
          <br />
        </div>
      );
    } else if (
      this.state.response?.data !== undefined &&
      this.state.response?.data !== null &&
      this.state.response?.data !== "" &&
      this.state.issueQrTicket === true
    ) {
      return (
        <div className="booking-summary-date">
          {/* <div className="booking-summary-details">
            <strong className="sameHeads sameTextColor" style={{ color: this.color.headsColor }}>
              {this.TicketIssuedOn}
            </strong>
          </div> */}
          <p className="sameFont ">
            {/* {this.state.response?.data?.ticket_issue_time} */}
            {moment(this.state.response?.data?.ticket_issue_time).format(
              "DD-MMM-YYYY hh:mm A"
            )}
          </p>
          <br />
        </div>
      );
    } else {
      return null;
    }
  };

  // getTicketsWaiting = (lang) => {
  //   if (
  //     this.state.response?.data?.ticket_info !== undefined &&
  //     this.state.response?.data?.ticket_info !== null
  //   ) {
  //     return (
  //       <div className="booking-summary-wait">
  //         {/* <strong
  //           className="sameHeads sameTextColor"
  //           style={{ color: this.color.headsColor }}
  //         >
  //           {this.TotalWaitingTickets}
  //         </strong> */}

  //         <p className="sameFont">
  //           {/* {this.state.response?.data?.ticket_info.ticket_in_wait} */}
  //           {`${lang.ThereArePeople} ${this.state.response?.data?.ticket_info.ticket_in_wait} ${lang.TicketInWait} `}
  //         </p>

  //         <br />
  //       </div>
  //     );
  //   } else if (
  //     this.state.response?.data !== undefined &&
  //     this.state.response?.data !== null &&
  //     this.state.response?.data !== "" &&
  //     this.state.issueQrTicket === true
  //   ) {
  //     return (
  //       <div className="booking-summary-date">
  //         <div className="booking-summary-details">
  //           <strong
  //             className="sameHeads sameTextColor"
  //             style={{ color: this.color.headsColor }}
  //           >
  //             {this.state.response.IsTicketCalled === false
  //               ? this.TotalWaitingTickets
  //               : ""}
  //           </strong>
  //         </div>
  //         <p className="sameFont ">
  //           {this.state.response.IsTicketCalled === false
  //             ? this.state.response?.data?.category_waiting_tickets
  //             : ""}
  //         </p>
  //         <br />
  //       </div>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  // getService = () => {
  //   // console.log(this.state);
  //   // console.log(this.props.getData());
  //   debugger;
  //   if (
  //     this.state.response?.data?.previous_appointment_info !== undefined &&
  //     this.state.response?.data?.previous_appointment_info !== null
  //   ) {
  //     return (
  //       <div className="booking-summary-date">
  //         <strong
  //           className="sameHeads sameTextColor"
  //           style={{ color: this.color.headsColor }}
  //         >
  //           {this.state.response?.data?.previous_appointment_info
  //             .phone_service === ""
  //             ? null
  //             : this.For}{" "}
  //         </strong>
  //         <p className="sameFont">
  //           {this.state.response?.data?.previous_appointment_info
  //             .phone_service === ""
  //             ? null
  //             : this.state.response?.data?.previous_appointment_info
  //                 .phone_service}
  //         </p>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div className="booking-summary-date">
  //         {/* <strong>For a: </strong> */}
  //         {this.props.getData().phoneServiceName !== null &&
  //         this.props.getData().phoneServiceName !== undefined &&
  //         this.props.getData().phoneServiceName !== "" ? (
  //           <strong
  //             className="sameHeads"
  //             style={{ color: this.color.headsColor }}
  //           >
  //             {this.For}{" "}
  //           </strong>
  //         ) : null}
  //         <p className="sameFont">
  //           {this.props.getData().phoneServiceName == null &&
  //           this.props.getData().phoneServiceName == ""
  //             ? null
  //             : this.props.getData().phoneServiceName}
  //         </p>
  //       </div>
  //     );
  //   }
  // };

  renderTranslations = () => {
    let lang;
    if (localStorage.getItem("lang") === "es") {
      lang = window["localization"].es;
    } else if (localStorage.getItem("lang") === "ar") {
      lang = window["localization"].ar;
    } else if (localStorage.getItem("lang") === "en") {
      lang = window["localization"].en;
    } else if (localStorage.getItem("lang") === "ur") {
      lang = window["localization"].ur;
    } else {
      let defaultLang = this.defaultLanguage;
      lang = window["localization"][defaultLang];
    }

    this.cancelButtonText = lang.CancelAppointment;
    this.rescheduleButtonText = lang.Reschedule;
    this.Attention = lang.Attention;
    this.DoYouWantToRescheduleOrCancel = lang.DoYouWantToRescheduleOrCancel;
    this.For = lang.For;
    this.someThingWentWrong = lang.SomeThingWentWrong;
    this.error = lang.Error;
    this.AppointmentAlreadyCanceled = lang.AppointmentAlreadyCanceled;
    this.Ok = lang.Ok;
    this.AppointmentInfoNotValidToCancel = lang.AppointmentInfoNotValidToCancel;
    this.CantCancelApptTcktIssued = lang.CantCancelApptTcktIssued;
    this.AppointmentExpired = lang.AppointmentExpired;
    this.AlreadyServed = lang.AlreadyServed;
    this.AppointmentCanceledAutomatically = lang.ApptCanceledAutomatically;
    this.Yes = lang.Yes;
    this.No = lang.No;
    this.CancelTicketConfirmation = lang.CancelTicketConfirmation;
    this.TicketIssuedOn = lang.TicketIssuedTime;
    this.WaitTime = lang.WaitingTime;
    this.TotalWaitingTickets = lang.TicketInWait;
    this.UrlNotFound = lang.UrlNotFound;
    this.InternetConnectionError = lang.InternetConnectionError;
    this.Where = lang.AtThe;
    this.TicketNumber = lang.TicketNumber;
    this.BookingRef = lang.BookingRef;
    this.Name = lang.FirstNamePlaceholder;
    this.Email = lang.EmailAddressPlaceHolder;
    this.PhoneNumber = lang.PhoneNumberPlaceholder;
    this.NoOfPeople = lang.NoOfPeople;
    this.WaitTimeMsg = lang.EstimatedWaitTimeMessage;
    this.Greetings = lang.Greetings;
    this.ServerNotResponding = lang.ServerNotResponding;
    this.TicketNotFound = lang.TicketNotFound;
  };

  //API CALLS

  rescheduleOrCancelAppointment = async () => {
    swal(
      this.DoYouWantToRescheduleOrCancel,

      {
        icon: "warning",
        buttons: {
          reschedule: {
            text: this.rescheduleButtonText,
            value: "reschedule",
          },
          cancelAppointment: {
            text: this.cancelButtonText,
            value: "cancelAppointment",
            closeModal: false,
          },
        },
      }
    ).then(async (value) => {
      switch (value) {
        case "cancelAppointment":
          try {
            let response = await this.dataService.cancelAppointment(
              this.state.response?.appointment_number,
              this.state.response?.category_id,
              this.state.response?.branch_id,
              this.state.response?.user_id
            );
            swal.close();

            if (
              response?.data?.error !== undefined &&
              response?.data?.error === true
            ) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok,
                ""
              );
            } else {
              if (response?.data?.response.resp_status === 1) {
                localStorage.removeItem("confirmed");
                localStorage.removeItem("prevState");
                handler.redirect(`${window.location.origin}/${this.appRoute}`);
              } else if (response?.data?.response.resp_status === 6) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentAlreadyCanceled,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              } else if (response?.data?.response.resp_status === -5) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentInfoNotValidToCancel,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              } else if (response?.data?.response.resp_status === 2) {
                handler.showErrorMessage(
                  this.error,
                  this.CantCancelApptTcktIssued,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              } else if (response?.data?.response.resp_status === 7) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentExpired,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              } else if (response?.data?.response.resp_status === -2) {
                handler.showErrorMessage(
                  this.error,
                  this.AlreadyServed,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              } else if (response?.data?.response.resp_status === -3) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentCanceledAutomatically,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              } else {
                handler.showErrorMessage(
                  this.error,
                  this.someThingWentWrong,
                  this.Ok,
                  `${window.location.origin}/${this.appRoute}`
                );
              }
            }
          } catch (error) {
            if (error.message.includes("timeout")) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            } else {
              handler.showErrorMessage(
                this.error,
                this.someThingWentWrong,
                this.Ok
              );
            }
          }
          break;

        case "reschedule":
          console.log("reschedule Appointment");
          window.open(
            `${window.location.origin}/rescheduleappointment?lang=${
              language === undefined
                ? this.defaultLanguage.split("_")[0]
                : language
            }&appointmentnumber=${this.state.response?.appointment_number}`,
            "_blank"
          );

          break;

        default:
      }
    });
  };

  render() {
    this.renderTranslations();
    const queryStringColor = queryString.parse(window.location.search);
    var theme = queryStringColor.theme;

    let emailAddress = this.state.response?.user_id;
    let appointmentNumber;
    let appointmentDate;

    let appointmentBranchId = this.state.response?.branch_id;

    let lang;
    if (localStorage.getItem("lang") === "es") {
      lang = window["localization"].es;
    } else if (localStorage.getItem("lang") === "ar") {
      lang = window["localization"].ar;
    } else if (localStorage.getItem("lang") === "en") {
      lang = window["localization"].en;
    } else if (localStorage.getItem("lang") === "ur") {
      lang = window["localization"].ur;
    } else {
      let defaultLang = this.defaultLanguage;
      lang = window["localization"][defaultLang];
    }

    return (
      <div className="container">
        <div className="sl__modal">
          {this.state.dataLoaded ? (
            <div className="sl__modal-inner">
              <ModalHead
                heading={this.state.lang.YourAppointmentHasBeenUpdated}
              />
              <div className="sl__modal--content">
                <h2
                  className="sameTextColor"
                  style={{ color: this.color.headsColor }}
                >
                  {this.state.issueTicket === true ||
                  this.state.issueQrTicket === true
                    ? lang.IssueTicketConfirmedMessage
                    : lang.ThanksForAppointment}
                </h2>

                <div className="booking-final-container">
                  <div className="booking-summary-confirmation">
                    <strong className="top-text">
                      <strong
                        className="sameHeads sameTextColor"
                        style={{ color: this.color.headsColor }}
                      >
                        {lang.SeeYouOn}
                      </strong>
                    </strong>

                    {/* DATE TIME FOR APPOINTMENT FLOW */}
                    <div className="booking-summary-address ">
                      {this.getDateTime()}
                    </div>

                    <div className="booking-summary-address ">
                      {this.getTicketIssuedDateTime()}
                    </div>

                    {this.state.issueTicket === false &&
                    this.state.issueQrTicket === false ? (
                      <div className="booking-summary-address ">
                        {this.getBranchAddress()}
                      </div>
                    ) : null}

                    {this.state.issueQrTicket === false &&
                    this.state.issueTicket === false ? (
                      <div className="location-ic">
                        <a
                          target="_blank"
                          href={`${this.URL.mapUrl}${this.state.branch_name},${this.state.response?.branch_address}`}
                        >
                          <img
                            src={
                              theme === "dark" ? LocationDarkImg : LocationImg
                            }
                            style={{ width: "2%" }}
                          ></img>
                        </a>
                      </div>
                    ) : null}

                    <div className="booking-summary-bookingref">
                      {this.getAppointmentNumber()}
                    </div>

                    {this.state.issueQrTicket === false &&
                    this.state.issueTicket === false ? (
                      <div
                        className="img-btns"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          width: "100%",
                          margin: "0 auto",
                        }}
                      >
                        <div
                          className="calender-ic"
                          onClick={this.rescheduleOrCancelAppointment}
                        >
                          <img src={CalendarImg} style={{ width: "20%" }}></img>
                          <span
                            className="img-btn-link sameTextColor"
                            style={{
                              paddingLeft: "15px",
                              fontSize: "16px",
                              fontWeight: "bold",

                              color: this.color.headsColor,
                            }}
                          >
                            {lang.ModifyOrCancel}
                          </span>
                        </div>

                        <div className="calender-ic">
                          <a
                            href={`${this.URL.icsFileUrl}${emailAddress}_${appointmentNumber}_${appointmentDate}_${appointmentBranchId}.ics`}
                            target="_blank"
                            download
                            className="ics-lnk"
                          >
                            <img
                              src={CalendarImgBlack}
                              style={{ width: "20%" }}
                            ></img>
                            <span
                              className="img-btn-link sameTextColor"
                              style={{
                                paddingLeft: "15px",
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: this.color.headsColor,
                              }}
                            >
                              {lang.AddToCalendar}
                            </span>
                          </a>
                        </div>
                      </div>
                    ) : null}

                    <br />
                    {this.runApp.toLowerCase() === "samsung" ? (
                      <Preparation />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(UpdateAppointment);
